import { Button, Icon, Notification, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function ReviewMessageBadge({
  customMessageLength,
  setOpenCustomizeMessageModal,
  showReviewButton = true,
  cancelable = true
}) {
  const { t } = useTranslation();
  const [showCustomizedMessage, setShowCustomizedMessage] = React.useState(true);

  return (
    showCustomizedMessage && (
      <Notification
        status="info"
        isClosable={cancelable}
        onClose={() => setShowCustomizedMessage(false)}
        content={
          <S.ReviewMessageBadgeWrapper>
            <Icon name="success" />
            <Typography variant="body2Bold">
              {t('messagesCustomized', { length: customMessageLength })}
            </Typography>
            {showReviewButton && (
              <Button variant="link" onClick={() => setOpenCustomizeMessageModal(true)}>
                {t('reviewMessages')}
              </Button>
            )}
          </S.ReviewMessageBadgeWrapper>
        }
      />
    )
  );
}

export { ReviewMessageBadge };
